import React, { useEffect, useState } from "react";
import { NXPen, NXUser } from "../../icons";
import { InputField } from "../common";
import useApi from "../../api";
import { toast } from "react-toastify";

const Account = () => {
  const [formData, setFormData] = useState<any>()
  const [image, setImage] = useState<File | null>();
  const api = useApi()


  useEffect(()=>{
    api.getMe().then((response)=>{
      setFormData(response)
    }).catch((error)=>toast.error('Error fetch your info.'))
  }, [])

  const onChangeImage = (e: any) => {
    setImage(e.target.files[0])
    setFormData((prev:any)=>({...prev, avatar: image}))
  };

  const onChangeHandler = (e: any) => {
    const {name, value} = e.target
    setFormData((prev:any)=>({...prev, [name]: value}))
  }

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    
    const dataToSubmit = {...formData}

    if(image){
      dataToSubmit.avatar = image
    }else{
      delete dataToSubmit.avatar
    }

    api.updateMe(dataToSubmit).then((response)=>toast.success('Successfully updated.')).catch((error)=>toast.error('Failed to update.'))
  }

  return (
    <div>
      <div className="flex flex-col gap-2 z-40">
        <strong className="text-lg">Account Setting</strong>
        <span className="text-base-300 text-sm"> View and update your account details, profile, and more.</span>
      </div>
      <form className="pt-8" onSubmit={onSubmit}>
        <div>
          <div className="h-[200px] w-[200px] rounded-full relative">
            {formData?.avatar || image ? 
                <img
                  src={`${image ? URL.createObjectURL(image) : formData.avatar}`}
                  alt=""
                  className="h-[200px] w-[200px] rounded-full border border-base-200 object-cover"
                />
                :
                <NXUser className="w-[150px] h-[150px]"/>
              }
            <label
              htmlFor="change_image"
              className="border border-base-200 absolute bottom-6 right-1 w-8 h-8 rounded-full bg-primary-500 flex justify-center items-center p-2 cursor-pointer"
            >
              <NXPen className="h-6 w-6 z-50 stroke-white" />
            </label>
            <InputField
              id="change_image"
              type="file"
              className="hidden"
              onChange={(e) => onChangeImage(e)}
            />
          </div>
          <div className="flex flex-col sm:flex sm:flex-row justify-between gap-4 pt-6">
            <div className="flex flex-col w-full">
              <label htmlFor="first_name" className="text-sm text-base-300">
                First Name
              </label>
              <InputField
                id="first_name"
                name="first_name"
                type="text"
                value={formData?.first_name || ''}
                onChange={onChangeHandler}
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
              />
            </div>
            <div className="flex flex-col w-full">
              <label htmlFor="last_name" className="text-sm text-base-300">
                Last Name
              </label>
              <InputField
                id="last_name"
                name="last_name"
                type="text"
                value={formData?.last_name || ''}
                onChange={onChangeHandler}
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
              />
            </div>
          </div>
          <div className="flex flex-col sm:flex sm:flex-row gap-4 py-6">
            <div className="flex flex-col w-full">
              <label htmlFor="username" className="text-sm text-base-300">
                Username
              </label>
              <InputField
                id="username"
                name="username"
                type="text"
                value={formData?.username || ''}
                onChange={onChangeHandler}
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
              />
            </div>
            <div className="flex flex-col w-full">
              <label htmlFor="role" className="text-sm text-base-300">
                Designation
              </label>
              <InputField
                id="role"
                name="role"
                type="text"
                value={formData?.role || ''}
                onChange={onChangeHandler}
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
              />
            </div>
          </div>
          <div className="flex flex-col sm:flex sm:flex-row  justify-between gap-2 pb-4">
            <div className="flex flex-col gap-3 w-full">
              <label
                htmlFor="email"
                className="text-sm text-base-300"
              >
                Email
              </label>
              <InputField
                id="email"
                type="email"
                name="email"
                value={formData?.email || ''}
                onChange={onChangeHandler}
                className="w-full px-5 py-3 bg-secondary-50 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
              />
            </div>
            <div className="flex flex-col w-full">
              <label htmlFor="phone_number" className="text-sm text-base-300">
                Phone
              </label>
              <InputField
                id="phone_number"
                type="text"
                name="phone_number"
                value={formData?.phone_number || ''}
                onChange={onChangeHandler}
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
              />
            </div>
          </div>
        </div>
        <div className="flex justify-end pt-4">
          <button
            className="bg-primary-500 py-2 px-5 w-full md:w-[200px] text-white rounded-md"
            type="submit"
          >
            Save changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default Account;
